// Auto-generated by scripts/generateFactionSkinConfig.mjs
// Do not edit manually.

// eslint-disable-next-line no-unused-vars
import {FACTIONS} from '../../../constants/factions';
// eslint-disable-next-line no-unused-vars
import {PLAYER_COLORS} from '../../colors';

export const FACTION_SKINS_RATMEN = [{
  id: 'ratmen_arena',
  factionId: FACTIONS.RATMEN,
  name: 'Гладиатор',
  priceNumens: 7000,
  skinRank: 1,
  colors: [
    PLAYER_COLORS.ORANGE,
  ]
}, {
  id: 'ratmen_bog',
  factionId: FACTIONS.RATMEN,
  name: 'Болотный охотник',
  priceNumens: 27000,
  skinRank: 2,
  colors: [
    PLAYER_COLORS.LIGHT_GREEN,
  ]
}, {
  id: 'ratmen_swarm',
  factionId: FACTIONS.RATMEN,
  name: 'Патриарх гнезда',
  priceNumens: 85000,
  skinRank: 3,
  colors: [
    PLAYER_COLORS.YELLOW,
    PLAYER_COLORS.LIGHT_GREEN,
    PLAYER_COLORS.RED,
  ]
}, {
  id: 'ratmen_gold_legacy',
  factionId: FACTIONS.RATMEN,
  name: 'Клинок стоков',
  priceNumens: 80000,
  skinRank: 3,
  colors: [
    PLAYER_COLORS.YELLOW,
  ],
  excludedFromChests: true
}, {
  id: 'ratmen_ruby_legacy',
  factionId: FACTIONS.RATMEN,
  name: 'Полководец орды',
  priceCrystals: 300,
  skinRank: 4,
  colors: [
    PLAYER_COLORS.YELLOW,
    PLAYER_COLORS.RED,
  ],
  accentColor: PLAYER_COLORS.RED,
  excludedFromChests: true
}];
